var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvaxRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0H12C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H12.0001C18.6275 24 24.0001 18.6274 24.0001 12C24.0001 5.37258 18.6275 0 12.0001 0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9874 12.5549C15.2808 12.0482 15.7543 12.0482 16.0477 12.5549L17.8748 15.7624C18.1682 16.2692 17.9282 16.6826 17.3413 16.6826H13.6604C13.0803 16.6826 12.8402 16.2692 13.127 15.7624L14.9874 12.5549ZM11.4532 6.38009C11.7466 5.8733 12.2134 5.8733 12.5068 6.38009L12.9136 7.11361L13.8738 8.80069C14.1072 9.28081 14.1072 9.84761 13.8738 10.3277L10.653 15.9091C10.3596 16.3625 9.87282 16.6493 9.33269 16.6826H6.65869C6.07188 16.6826 5.83182 16.2759 6.12522 15.7624L11.4532 6.38009Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaxRounded);
export default __webpack_public_path__ + "static/media/avax-rounded.7f5e5d11587f5dc20cb439806c2d0c0e.svg";
export { ForwardRef as ReactComponent };